// @flow
import React, { Fragment } from 'react';
import LetterHead from 'components/letter/LetterHead';
import LetterContent from '../LetterContent';
import './LetterPlaceholder.scss';

type Props = {};

const LetterPlaceholder = (props: Props) => (
  <Fragment>
    <LetterHead.Placeholder />
    <LetterContent.Placeholder />
  </Fragment>
);

export default LetterPlaceholder;



// WEBPACK FOOTER //
// ./src/components/letter/LetterPlaceholder/LetterPlaceholder.js